import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGatewayResponse } from '@/Module/Core/Model/ApiModel';
import type { ILessonSection } from '@/Module/Lesson/Model/DataModel';
import type { IState } from '@/Module/Store/Model';
import type { IGetLessonByTeacherId } from '@/Module/Teacher/Model/ApiModel';
import { TeacherService } from '@/Module/Teacher/Service';

export const getLessonByTeacherIdAction = createAsyncThunk<
  IGatewayResponse<ILessonSection[]>,
  IGetLessonByTeacherId['teacherId']
>('lesson/getLessonListByTeacherId', async (teacherId, { signal, getState }) => {
  return TeacherService.getLessonByTeacherId(
    {
      teacherId,
      pageNo: (getState() as IState).lessonTeacher.page,
      pageCount: (getState() as IState).lessonTeacher.rows,
    },
    signal,
  ).then(({ data }) => data);
});
